export default {
	spacing: 4,
	rightSize: 4,
	spacingStyle: (spacing) => ({
		padding: spacing * 8
	}),
}